import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { of } from 'rxjs';
import { ToastService } from '../../../common-modules/services/toast.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../modules/auth/services/auth.service';
import { UserIdp } from '../../modules/users/enums/user-idp.enum';

@Component({
    selector: 'app-switcher',
    templateUrl: './app-switcher.component.html',
    styleUrls: ['./app-switcher.component.scss'],
    standalone: false,
})
export class AppSwitcherComponent {
    @Input()
    public align: 'flex-start' | 'center' | 'flex-end' = 'flex-start';

    @ViewChild('appsButton')
    private appsButton: ElementRef<HTMLButtonElement>;

    @ViewChild('appsMenu')
    private appsMenu: ElementRef<HTMLButtonElement>;

    @ViewChild('backdropClose')
    private backdropClose: ElementRef<HTMLButtonElement>;

    constructor(
        private readonly authService: AuthService,
        private readonly toastService: ToastService,
        private readonly http: HttpClient,
    ) {}

    public isUserUsingSso(): boolean {
        return this.authService.jwtUser?.UserIdp === UserIdp.GravityZone;
    }

    public getAppButtonTooltip(): string {
        return this.isUserUsingSso()
            ? $localize`Open GravityZone Control Center.`
            : $localize`SSO login is required to access GravityZone.`;
    }

    public showAppSwitcherMenu(): void {
        this.calculateMenuPosition();

        this.appsMenu.nativeElement.style.display = 'block';
        this.backdropClose.nativeElement.style.display = 'block';
    }

    public hideAppSwitcherMenu(): void {
        this.appsMenu.nativeElement.style.display = 'none';
        this.backdropClose.nativeElement.style.display = 'none';
    }

    private calculateMenuPosition(): void {
        const target = this.appsButton.nativeElement;
        const offsetTop = target ? target.offsetTop : 0;

        this.appsMenu.nativeElement.style.top = String(offsetTop + 'px');
    }

    public openGravityZone(): void {
        this.http.get<{ url: string }>('/v2/users/sso/get-gravity-zone-url').subscribe({
            next: ({ url }: { url: string }) => {
                window.open(url);
            },
            error: (err) => {
                this.toastService.showError(err.error._error.error_description, {
                    duration: 5000,
                });

                return of(null);
            },
        });
    }
}
